import { AxiosResponse } from 'axios';
import {
  OpenAmAuthenticateResponse,
  OpenAmAuthenticateResponseOfLoginWithUsernamePassword,
  OpenAMSessionCheckResponse,
} from '../@types/OpenAmInitialData';
import { keycloakClient } from './keycloakClient';
import { openAmClient } from './openamClient';

export interface AuthenticationResource {
  checkSession(): Promise<AxiosResponse<OpenAMSessionCheckResponse>>;

  getInitialData(): Promise<
    AxiosResponse<OpenAmAuthenticateResponse> | AxiosResponse<OpenAmAuthenticateResponseOfLoginWithUsernamePassword>
  >;

  postLogin(authId: string, email: string, password: string, captchaValue: string): Promise<OpenAmAuthenticateResponse>;

  postPhoneNumber(authId: string, phoneNumber: string, stageName: string): Promise<OpenAmAuthenticateResponse>;

  postSMSCode(authId: string, smsCode: string): Promise<OpenAmAuthenticateResponse>;

  postSMSCodeChange2FA(authId: string, smsCode: string): Promise<OpenAmAuthenticateResponse>;

  postAuthenticatorCode(authId: string, authenticatorCode: string): Promise<OpenAmAuthenticateResponse>;

  postYoloOtpCode(authId: string, otpCode: string): Promise<OpenAmAuthenticateResponse>;

  reSendYoloOtpCode(authId: string): Promise<OpenAmAuthenticateResponse>;

  postMSISDNVerificatorCode(authId: string, otpCode: string): Promise<OpenAmAuthenticateResponse>;

  reSendMSISDNVerificatorCode(authId: string): Promise<OpenAmAuthenticateResponse>;

  postTestLogin(authId: string): Promise<OpenAmAuthenticateResponse>;
}

// @ts-ignore
export const authenticationResource: AuthenticationResource = window.isKc ? keycloakClient : openAmClient;
